class Controller {
  constructor($mdDialog, GoogleMaps, officeLocationCoords) {
    "ngInject";

    this.$mdDialog = $mdDialog;
    this.googleMapsUrl = GoogleMaps.getSource();
    this.coords = officeLocationCoords;
  }

  close() {
    this.$mdDialog.hide();
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/corporate/officeLocationDialog/officeLocationDialog.controller.js